import { soFetch } from 'so-fetch';
import * as constants from './config-constants';

export function getConfig() {
  return soFetch('/env', {
    actionType: constants.GET_CONFIG,
    responseBinding: 'config',
  });
}

export function firstFrameLoad() {
  return {
    type: constants.FIRST_FRAME_LOAD,
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/config/config-actions.js